import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
export var megamenuBehavior = function megamenuBehavior() {
  Alpine.data('megamenuBehavior', function () {
    return {
      menuIsOpen: false,
      headerMain: null,
      headerMainHeight: 0,
      headerHeight: 0,
      adminToolbar: null,
      adminToolbarHeight: 0,
      menuNav: null,
      subMenus: [],
      init: function init() {
        this.menuNav = this.$el.querySelector('.o-megamenu-nav');
        this.menuIsOpen = breakpoint.isDesktop;
        this.$watch('menuIsOpen', this.menuToggled);
        this.updateMenuHeight();
        this.updateSubMenuHeight();
      },
      menuToggled: function menuToggled(menuIsOpen) {
        if (menuIsOpen && !breakpoint.isDesktop) {
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      },
      calculateAdminMenuHeight: function calculateAdminMenuHeight() {
        this.adminToolbar = document.body.querySelector('.toolbar-bar');
        if (this.adminToolbar) {
          this.adminToolbarHeight = this.adminToolbar.offsetHeight;
        }
        return this.adminToolbarHeight;
      },
      calculateHeaderHeight: function calculateHeaderHeight() {
        var _this$headerMain;
        this.headerMain = document.body.querySelector('.o-header__main');
        this.headerMainHeight = (_this$headerMain = this.headerMain) === null || _this$headerMain === void 0 ? void 0 : _this$headerMain.offsetHeight;
        this.headerHeight = this.headerMainHeight;
        return this.headerHeight;
      },
      updateMenuHeight: function updateMenuHeight() {
        this.calculateAdminMenuHeight();
        this.calculateHeaderHeight();
        if (this.adminToolbarHeight) {
          this.headerHeight = this.headerHeight + this.adminToolbarHeight;
        }
        if (breakpoint.isTouch) {
          this.menuNav.style.height = "calc(100dvh - ".concat(this.headerHeight, "px)");
        } else {
          this.menuNav.style.height = '';
        }
      },
      updateSubMenuHeight: function updateSubMenuHeight() {
        var _this$$el$querySelect,
          _this = this;
        this.calculateAdminMenuHeight();
        this.calculateHeaderHeight();
        this.subMenus = (_this$$el$querySelect = this.$el.querySelectorAll('.o-megamenu-submenu')) !== null && _this$$el$querySelect !== void 0 ? _this$$el$querySelect : [];
        this.subMenus.forEach(function (subMenu) {
          if (breakpoint.isTouch) {
            var submenuControls = subMenu.querySelector('.o-megamenu-submenu__menu-controls');
            if (subMenu.classList.contains('o-megamenu-submenu--level-1')) {
              subMenu.style.height = "calc(100dvh - ".concat(_this.adminToolbarHeight, "px)");
            }
            if (submenuControls) {
              submenuControls.style.height = "".concat(_this.headerMainHeight, "px");
            }
          } else {
            subMenu.style.height = '';
          }
        });
      },
      bindMegamenuNav: {
        '@resize.window.stop.debounce': function resizeWindowStopDebounce() {
          this.menuIsOpen = breakpoint.isDesktop;
          this.updateMenuHeight();
          this.updateSubMenuHeight();
        },
        '@click': function click() {
          this.updateSubMenuHeight();
        },
        '@click.outside': function clickOutside() {
          this.menuIsOpen = breakpoint.isDesktop;
        }
      }
    };
  });
};
export var megamenuItemBehavior = function megamenuItemBehavior() {
  Alpine.data('megamenuItemBehavior', function () {
    var hasSubMenu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return {
      hasSubMenu: hasSubMenu,
      subMenuIsOpen: false,
      init: function init() {
        var _this2 = this;
        this.hasSubMenu = hasSubMenu;
        this.$watch('subMenuIsOpen', function () {
          if (_this2.hasSubMenu) {
            _this2.$dispatch('megamenu-submenu-is-open', _this2.subMenuIsOpen);
          }
        });
      },
      toggleSubMenu: function toggleSubMenu() {
        if (breakpoint.isTouch) {
          this.$event.preventDefault();
        }
        this.subMenuIsOpen = !this.subMenuIsOpen;
      },
      handleClickSubMenuButton: function handleClickSubMenuButton() {
        var hasHref = this.$el.getAttribute('href') !== null;
        var isSubMenuButton = this.$el.getAttribute('x-ref').includes(['megamenuSubMenuButton', 'megamenuSubMenuBackButton']);
        var notLinkAndHasSubMenu = this.hasSubMenu && (!hasHref || breakpoint.isTouch);
        if (notLinkAndHasSubMenu || isSubMenuButton) {
          this.toggleSubMenu();
        }
      },
      bindMegamenuSubmenuToggle: {
        '@click': function click() {
          this.handleClickSubMenuButton();
        },
        '@keydown.escape': function keydownEscape() {
          this.subMenuIsOpen = false;
        }
      },
      bindMegamenuItem: {
        '@mouseenter': function mouseenter() {
          if (breakpoint.isDesktop) {
            this.subMenuIsOpen = true;
          }
        },
        '@mouseleave': function mouseleave() {
          if (breakpoint.isDesktop) {
            this.subMenuIsOpen = false;
          }
        },
        '@click.once': function clickOnce() {
          if (breakpoint.isTouch) {
            this.subMenuIsOpen = true;
          }
        },
        '@click.outside': function clickOutside() {
          this.subMenuIsOpen = false;
        },
        '@keydown.escape': function keydownEscape() {
          if (this.hasSubMenu) {
            if (breakpoint.isDesktop) {
              this.$refs.megamenuSubMenuButton.focus();
            } else {
              this.$refs.megamenuSubMenuBackButton.focus();
            }
          }
        }
      },
      bindMegamenuItemLink: {
        '@click': function click() {
          this.handleClickSubMenuButton();
          if (breakpoint.isDesktop) {
            this.subMenuIsOpen = !this.subMenuIsOpen;
          }
        }
      }
    };
  });
};